import { render, staticRenderFns } from "./EmojiBottomBar.vue?vue&type=template&id=4afbeb54&"
import script from "./EmojiBottomBar.vue?vue&type=script&lang=js&"
export * from "./EmojiBottomBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports